/**
 * Slim banner shown above the app shell when the session is acting
 * as a VAU. Built from primitives (`Box` + `Flex`) rather than
 * Axiom's `Alert` because Alert centers and stacks its content —
 * we want left-aligned, single-line so the banner stays one row tall.
 *
 * Reads ``useVAUContext`` and renders only when ``is_assumed`` is
 * true. "Switch back" calls the release mutation; the hook's
 * onSuccess does the pseudo-reload (cache invalidate + React
 * Router navigate).
 */

import { IconCircleInfo } from '@optiaxiom/icons';
import { Box, Button, Flex, Text } from '@optiaxiom/react';

import { useReleaseVAU, useVAUContext } from '@frontend/features/vau/hooks/useVAUContext';

export const AssumedVAUBanner = () => {
  const { data } = useVAUContext();
  const release = useReleaseVAU();

  if (!data?.is_assumed) return null;

  return (
    <Box
      role="status"
      px="16"
      py="4"
      borderB="1"
      borderColor="border.default"
      style={{ backgroundColor: 'rgba(56, 121, 217, 0.10)' }}
    >
      <Flex flexDirection="row" alignItems="center" gap="8">
        <IconCircleInfo />
        <Text fontSize="sm">
          Acting as <strong>{data.vau_name}</strong>. Actions you take are recorded under this
          VAU&apos;s identity.
        </Text>
        <Button
          appearance="subtle"
          size="sm"
          onClick={() => release.mutate()}
          disabled={release.isPending}
        >
          Switch back
        </Button>
      </Flex>
    </Box>
  );
};
